export * from './lang'
export * from './env'
export * from './dom'
export * from './options'
export * from './component'
export * from './debug'
export { defineReactive } from '../observer/index'



//////////////////
// WEBPACK FOOTER
// ./~/vue/src/util/index.js
// module id = ./node_modules/vue/src/util/index.js
// module chunks = 53